// dev/hml azure
let apiUrlBase = process.env.VUE_APP_API_URL
export default {
  apiUrlBase: apiUrlBase
}



// WEBPACK FOOTER //
// ./src/services/ambiente.js